type Suggestion = {
  occasion: string
  quote: string
}

type SuggestionChipsProps = {
  suggestions: Suggestion[]
  onSelect: (text: string, occasion: string) => void
  disabled?: boolean
}

export function SuggestionChips({ suggestions, onSelect, disabled }: SuggestionChipsProps) {
  if (suggestions.length === 0) return null

  return (
    <div className="suggestion-chips" role="group" aria-label="Quick prompts">
      <div className="suggestion-chips-row">
        {suggestions.map((item) => (
          <button
            key={item.occasion}
            type="button"
            className="suggestion-chip"
            disabled={disabled}
            title={item.quote}
            onClick={() =>
              onSelect(
                `Build me a watch for ${item.occasion.toLowerCase()} — ${item.quote}`,
                item.occasion,
              )
            }
          >
            {item.occasion}
          </button>
        ))}
      </div>
    </div>
  )
}
